
import React, { lazy, useCallback } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Avatar,
  Box,
  Tooltip,
  Menu,
  CssBaseline,
  Container,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ResponsiveAppBarViewModel from "./viewmodel/customer360/ResponsiveAppBar";
import useHeaderStyles from "./styles/component/ResponsiveAppBar.styles";
import { HeaderBackground, HeaderText } from "./constant/color";
import { COUNTRY_CONFIG, CountryCode } from "./constant/appConsatnt";
import { ServiceCountry } from "./constant/enum";

// Lazy load components that aren't immediately needed
// LeftDrawer is only loaded when user hovers over menu button or opens drawer
const LeftDrawer = lazy(() => import("./LeftDrawer"));

const SERVICE_COUNTRY: ServiceCountry = (import.meta.env.VITE_ServiceCountry as ServiceCountry) || ServiceCountry.IN;

const ResponsiveAppBar: React.FC = () => {
  const {
    avatar,
    drawerOpen,
    setDrawerOpen,
    anchorElUser,
    setAnchorElUser,
  } = ResponsiveAppBarViewModel();

  const classes = useHeaderStyles();

  // Use color constants for header styling
  const headerBackgroundColor = HeaderBackground;
  const textColor = HeaderText;

  // Get current country configuration
  const currentCountry = COUNTRY_CONFIG[SERVICE_COUNTRY as CountryCode] || COUNTRY_CONFIG[ServiceCountry.IN];

  // Preload LeftDrawer when user hovers over menu button
  const handleMenuHover = useCallback(() => {
    const componentImport = import("./LeftDrawer");
    // Preload but don't wait for it
    componentImport.catch(() => {
      // Silently ignore preload errors
    });
  }, []);

  return (
    <>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar} style={{ backgroundColor: headerBackgroundColor }}>
        <Container maxWidth={false} disableGutters style={{background: headerBackgroundColor}}>
          <Toolbar className={classes.toolbar}>
            <Box className={classes.leftBox}>
              <IconButton
                edge="start"
                className={classes.menuButton}
                aria-label="menu"
                style={{ color: textColor }}
                onMouseEnter={handleMenuHover}
                onClick={() => setDrawerOpen(true)}
              >
                <MenuIcon />
              </IconButton>
              <img
                src='https://huskpowersystems.com/wp-content/themes/HuskPower/images/Husk.png'
                width={100}
                alt="HUSK Logo"
                className={classes.logo}
                onClick={() => window.close()}
                aria-label="Close tab"
              />
            </Box>

            <Typography variant="h6" noWrap className={classes.title} style={{ color: textColor }}>
              Husk Power Systems
            </Typography>

            <Box className={classes.rightBox}>
              <Box className={classes.countryBox} style={{ color: textColor }}>
                <img
                  src={currentCountry.flag}
                  alt={currentCountry.alt}
                  className={classes.flag}
                />
                {currentCountry.name}
              </Box>
              <Tooltip title="User menu">
                <IconButton
                  onClick={(e) => setAnchorElUser(e.currentTarget)}
                  className={classes.avatarButton}
                >
                  <Avatar className={classes.avatar}>
                    {avatar || "U"}
                  </Avatar>
                </IconButton>
              </Tooltip>

              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                keepMounted
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                open={Boolean(anchorElUser)}
                onClose={() => setAnchorElUser(null)}
              >
                
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <LeftDrawer open={drawerOpen} setOpen={setDrawerOpen} />
      <Toolbar />
    </>
  );
};

export default ResponsiveAppBar;
